import React from 'react';
import {
  Link,
} from 'react-router-dom';
import './Sec1.css';

const Documents = () => (
  <div>
    <br /><br />
    <h2>Documents and Policies</h2>

    <ul>
      <li>
        <Link to='/privacy' style={{textDecoration: 'none'}}>
          <p>Privacy Policy</p>
        </Link>
      </li>
      <li>
        <Link to='/aup' style={{textDecoration: 'none'}}>
          <p>Acceptable Use Policy</p>
        </Link>
      </li>
      <li>
        <Link to='/tos' style={{textDecoration: 'none'}}>
          <p>Terms of Service</p>
        </Link>
      </li>
      <li>
        <Link to='/app-privacy' style={{textDecoration: 'none'}}>
          <p>PDfiber CommmandIQ App Privacy Policy</p>
        </Link>
      </li>
      <li>
        <Link to='/app-terms' style={{textDecoration: 'none'}}>
          <p>PDFiber CommandIQ Terms and Conditions</p>
        </Link>
      </li>
      <li>
        <Link to='/app-support' style={{textDecoration: 'none'}}>
          <p>PDFiber CommandIQ Support</p>
        </Link>
      </li>
      <li>
        <Link to='/app-deletion' style={{textDecoration: 'none'}}>
          <p>PDFiber CommandIQ App Deletion</p>
        </Link>
      </li>
      <li>
        <Link to='/bundle' style={{textDecoration: 'none'}}>
          <p>Bundle Discounts available</p>
        </Link>
      </li>
    </ul>
  </div>
);

export default Documents;


// WEBPACK FOOTER //
// ./src/components/sections/Documents.js